export const ROUTES = {
  public: {
    login: '/login'
  },
  authenticated: {
    dashboard: '/inicio',
    user: {
      profile: '/perfil'
    },
    registers: {
      birthdays: '/aniversariantes',
      paymentsheet: '/folha-de-pagamento',
      timesheet: '/espelho-ponto',
      codeconduct: '/codigo-conduta'
    }
  }
};
